import axios from "axios";
import { API_BASE_URL } from "../config";
import { isTokenExpired } from "../utilities/globalServiceUtils";

const triggerSessionExpired = () => {
    try {
        const path = `${window.location.pathname}${window.location.search}${window.location.hash}` || "/";
        localStorage.setItem("postLoginRedirect", path);
        localStorage.setItem("sessionExpired", "1");
        window.dispatchEvent(new Event("session-expired"));
    } catch (e) {
        // no-op
    }
};

// Create a custom axios instance
const customHttp = axios.create({
    baseURL: API_BASE_URL || "http://localhost:5000",
});

// Add a request interceptor
customHttp.interceptors.request.use(
    (config) => {
        if (config?.skipAuth) {
            return config;
        }

        const token = localStorage.getItem("token");

        if (token) {
            try {
                // Check if token is expired (optional utility)
                if (isTokenExpired(token)) {
                    console.warn("Token expired, clearing session");
                    localStorage.clear();
                    triggerSessionExpired();
                    return Promise.reject({ message: "Token expired" });
                }

                // Add token to headers
                config.headers["Authorization"] = `Bearer ${token}`;
            } catch (error) {
                console.error("Error validating token:", error);
            }
        }

        return config;
    },
    (error) => Promise.reject(error)
);

// Add a response interceptor to catch 401/403 and redirect
customHttp.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error?.config?.skipAuth) {
            return Promise.reject(error);
        }

        const status = error?.response?.status;
        const msg = String(error?.response?.data?.message || error?.message || "").toLowerCase();
        if (status === 401 || msg.includes("token") || msg.includes("session")) {
            triggerSessionExpired();
        }
        return Promise.reject(error);
    }
);

export default customHttp;
